import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { prettifyDate } from '../../common/helpers/general'

import { BOOKING, BookingContext } from './BookingContext'
import LeftCaret from '../common/icons/LeftCaret'
import { getBookingStatus } from '../helpers/bookingHelper'

import HotelImage from '../hotel/HotelImage'

const BookingDetails = ({ booking }) => {
  const { dispatch } = useContext(BookingContext)

  const _closeMe = () => {
    dispatch({ type: BOOKING.SET, payload: null })
  }

  const _handleCancel = () => {
    // cancel this booking, send to api
  }

  const _renderField = (fieldName, value) => {
    if (!value)
      return null

    return (
      <React.Fragment>
        <dt>{fieldName}</dt>
        <dd>{value}</dd>
      </React.Fragment>
    )
  }

  const hasTourData = () => (
    booking.tour_confirmation_code || booking.preview_center || booking.scheduled_tour_date ||
      booking.scheduled_tour_time
  )

  return (
    <aside className="details" id="booking-info">
      <div className="booking info scrollable">
        <button
          className="close blue"
          onClick={ () => _closeMe()}
          >
          <LeftCaret />
        </button>

        <HotelImage
          hotel={booking.hotel}
          />

        <header className="header">
          <div className="text">
            <h3 className="title">{booking.hotel.name}</h3>
            <address>{booking.hotel.address}</address>
          </div>
          <div className="actions">
            {false && <button className="button">View Hotel</button>}
          </div>
        </header>

        <hr />

        <dl className="space-between single-line">
          <dt>Booking Status</dt>
          <dd>{getBookingStatus(booking)}</dd>
          <dt>Room Type</dt>
          <dd>{booking.room_type}</dd>
          {booking.lodging_confirmation_code && (
            <React.Fragment>
              <dt>Room Conf Code</dt>
              <dd>{booking.lodging_confirmation_code}</dd>
            </React.Fragment>
          )}
          <dt>Arrival & Departure</dt>
          <dd>
            {prettifyDate(booking.arrival)} to {prettifyDate(booking.departure)}
          </dd>
        </dl>

        <hr />

        <dl className="space-between single-line">
          {_renderField('Tour Conf Code', booking.tour_confirmation_code)}
          {_renderField('Preview Center', booking.preview_center)}
          {_renderField('Scheduled Tour Date', booking.scheduled_tour_date && prettifyDate(booking.scheduled_tour_date))}
          {_renderField('Scheduled Tour Time', booking.scheduled_tour_time)}
        </dl>

        {hasTourData() &&  <hr />}

        <h3>Guest Information</h3>
        <p>
          {booking.first_name} {booking.last_name} <br />
          {booking.phone} <br />
          {booking.email}
        </p>

        <div className="actions">
          {false && (
            <button
              className="button primary"
              onClick={(e) =>
                window.confirm('Are you sure you wish to cancel this booking?') &&
                _handleCancel(e)
              }
              disabled={true}
            >
              Cancel Booking
            </button>
          )}
        </div>
      </div>
    </aside>
  )
}

BookingDetails.propTypes = {
  booking: PropTypes.object,
}

export default BookingDetails
